import {
  CustomFieldInstance,
  CustomFormFieldType,
  CustomFormTemplate
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  relatedFieldType: CustomFormFieldType;
}

interface ResponseDataType extends CustomFormTemplate {
  custom_field_instances: CustomFieldInstance[];
}

export const getCustomFormTemplateCustomFieldInstancesRequest = ({
                                                                   token,
                                                                   relatedFieldType
                                                                 }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-template/custom-field-instances/${ relatedFieldType }`, {
    token,
  });
};